const $ = jQuery.noConflict();

export default function initTabs() {
    $(".btn-tab").click(function onClick(eventObject) {
        eventObject.preventDefault();

        const $block = $(this).closest(".block");
        const tab = $(this).data("tab");

        $block.find(".tabs-nav .tab-item").removeClass("tab-item-active");
        $(this).parent().addClass("tab-item-active");
        $block.find("[data-tabcontent]").removeClass("tab-content-active");
        $block
            .find(`[data-tabcontent="${tab}"]`)
            .addClass("tab-content-active");
    });
}
